/**
 * Enum variable to indicate the different DebugLevels for Logging.
 *
 * @namespace Logger
 * @class DebugLevel
 * @static
 */
 (function (root, factory) {
   if (typeof define === 'function' && define.amd) {
     //AMD
     define([], factory);
   } else if (typeof exports === 'object') {
     // Node, CommonJS-like
     module.exports = factory();
   } else {
     throw 'Only AMD and CommonJS imports are supported.';
   }
 }(this, function () {
  'use strict';

  return {
    /**
     * Debug (lowest, most verbose, level)
     * @property DEBUG
     * @type {Number}
     * @static
     * @default 0
     */
    DEBUG: 0,
    /**
     * Info (less verbose than DEBUG)
     * @property INFO
     * @type {Number}
     * @static
     * @default 1
     */
    INFO: 1,
    /**
     * Warning (less verbose than INFO)
     * @property WARNING
     * @type {Number}
     * @static
     * @default 2
     */
    WARNING: 2,
    /**
     * Error (less verbose than WARNING)
     * @property ERROR
     * @type {Number}
     * @static
     * @default 3
     */
    ERROR: 3,
    /**
     * Silence (no messages logged)
     * @property SILENCE
     * @type {Number}
     * @static
     * @default 4
     */
    SILENCE: 4
  };
}));
